var map = {
	"./ArrowDropDownFilled.svg": 30307,
	"./CRM.png": 363,
	"./DCBg.png": 94477,
	"./DesktopBgDC.png": 69721,
	"./DoseCheckDesktopLogo.svg": 12987,
	"./Ellipse.png": 42045,
	"./LibreView.png": 34674,
	"./bgDrop.png": 13913,
	"./bgMeter.png": 69247,
	"./check_circle.png": 5404,
	"./dc-logo-header.svg": 93496,
	"./dc-logo.svg": 42126,
	"./header_logo_Br.png": 80701,
	"./header_logo_isage.png": 89412,
	"./image-10.jpg": 64200,
	"./isage-logo-print.png": 2722,
	"./logo-admin.png": 74848,
	"./logo-login.png": 95206
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9735;